import React from "react";

export const ScrapeJobsRow = ({ job, onDelete, onEdit, deleteLoading }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <tr className="border-t border-jp-line hover:bg-jp-section h-11">
      <td className="px-4 text-[11px] text-jp-ink align-middle">
        {job.jobName}
      </td>
      <td className="px-4 text-[11px] text-jp-ink align-middle">
        {job.playerName || "N/A"}
      </td>
      <td className="px-4 text-[11px] text-jp-ink align-middle">
        {job.team?.name || "N/A"}
      </td>
      <td className="px-4 text-[11px] text-jp-ink align-middle">
        {job.position || "N/A"}
      </td>
      <td className="px-4 text-[11px] text-jp-ink align-middle">
        {job.schedule || "CSV Import"}
      </td>
      <td className="px-4 text-[11px] text-jp-ink align-middle">
        {formatDate(job.lastRun)}
      </td>
      <td className="px-4 text-[11px] align-middle">
        <span
          className={`px-2 py-1 rounded ${
            job.status === "Active"
              ? "bg-green-900/30 text-green-600 dark:text-green-400"
              : job.status === "Paused"
              ? "bg-yellow-900/30 text-amber-600 dark:text-yellow-400"
              : "bg-red-900/30 text-red-600 dark:text-red-400"
          }`}
        >
          {job.status}
        </span>
      </td>
      <td className="px-4 text-[11px] text-jp-ink align-middle">
        <button
          onClick={() => onEdit(job)}
          className="mr-2 text-sky-600 dark:text-sky-300 hover:text-jp-accent hover:underline"
        >
          Edit
        </button>
        <button
          onClick={() => onDelete(job._id)}
          disabled={deleteLoading}
          className="text-red-600 dark:text-red-400 hover:text-red-300 hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {deleteLoading ? "Deleting..." : "Delete 🗑"}
        </button>
      </td>
    </tr>
  );
};
